
import { types } from "./types";
import Aggregator from "./Aggregator/Aggregator";
import KMEANS from "./KMEANS/KMEANS";
import CoxProportionalHazards from "./CoxProportionalHazards/CoxProportionalHazards";
import DistributedRandomForest from "./DistributedRandomForest/DistributedRandomForest";
import DeepLearning from "./DeepLearning/DeepLearning";
import GeneralizedLinear from "./GeneralizedLinear/GeneralizedLinear";
import GeneralizedLowRank from "./GeneralizedLowRank/GeneralizedLowRank";
import GradientBoostingMachine from "./GradientBoostingMachine/GradientBoostingMachine";
import IsolationForest from "./IsolationForest/IsolationForest";
import NaiveBeans from "./NaiveBeans/NaiveBeans";
import TargetEncoder from "./TargetEncoder/TargetEncoder";
import World2Vec from "./World2Vec/World2Vec";
import RuleFit from "./RuleFit/RuleFit";
import PrincipalComponentsAnalysis from "./PrincipalComponentsAnalysis/PrincipalComponentsAnalysis";
import StackedEnsemble from "./StackedEnsemble/StackedEnsemble";





/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @param       showAlert -  show alert
 * @Returns     Component
 * @Author      Kerem Karadeniz
 */
function Actions(
    action,
    showAlert,
    variables,
    setOpenVariable,
    automId,
    variableRender
) {
    switch (action.actionName) {
        case types.AGGREGATOR:
            return (
                <Aggregator
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    automId={automId}
                />
            );
        case types.KMEANS:
            return (
                <KMEANS
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    automId={automId}
                />
            );
        case types.COXPROPORTIONALHAZARDS:
            return (
                <CoxProportionalHazards
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    automId={automId}
                />
            );
        case types.DISTRIBUTEDRANDOMFOREST:
            return (
                <DistributedRandomForest
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    automId={automId}
                />
            );
        case types.DEEPLEARNING:
            return (
                <DeepLearning
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    automId={automId}
                />
            );
        case types.GENERALIZEDLINEAR:
            return (
                <GeneralizedLinear
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    automId={automId}
                />
            );
        case types.GENERALIZEDLOWRANK:
            return (
                <GeneralizedLowRank
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    automId={automId}
                />
            );
        case types.GRADIENTBOOSTINGMACHINE:
            return (
                <GradientBoostingMachine
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    automId={automId}
                />
            );
        case types.ISOLATIONFOREST:
            return (
                <IsolationForest
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    automId={automId}
                />
            );
        case types.NAIVEBEANS:
            return (
                <NaiveBeans
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    automId={automId}
                />
            );
        case types.TARGETENCODER:
            return (
                <TargetEncoder
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    automId={automId}
                />
            );
        case types.WORLD2VEC:
            return (
                <World2Vec
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    automId={automId}
                />
            );
        case types.RULEFIT:
            return (
                <RuleFit
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    automId={automId}
                />
            );
        case types.PRINCIPALCOMPONENTSANALYSIS:
            return (
                <PrincipalComponentsAnalysis
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    automId={automId}
                />
            );
        case types.STACKEDENSEMBLE:
            return (
                <StackedEnsemble
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    automId={automId}
                />
            );
            default: break;


    }
}

export default Actions;
